export const AUTH_PROVIDER = {
  CUSTOM_OAUTH2: "custom_oauth2",
  MICROSOFT_ENTRA_ID: "microsoft_entra_id",
};

const SESSION_KEYS = [
  "access_token",
  "refresh_token",
  "user",
  "auth_provider",
  "sso_state",
  "pkce_code_verifier",
  "code_verifier",
];

const LOGOUT_NOTIFICATION_KEY = "logout_notification_message";

const clearSsoCallbackMarkers = () => {
  const keysToRemove = [];

  for (let index = 0; index < sessionStorage.length; index += 1) {
    const key = sessionStorage.key(index);

    if (key && key.startsWith("sso_callback_")) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => sessionStorage.removeItem(key));
};

export const storeAuthSession = ({
  accessToken,
  refreshToken,
  user = null,
  provider = AUTH_PROVIDER.CUSTOM_OAUTH2,
}) => {
  sessionStorage.setItem("access_token", accessToken);
  sessionStorage.setItem("refresh_token", refreshToken);
  sessionStorage.setItem("auth_provider", provider);

  if (user) {
    sessionStorage.setItem("user", JSON.stringify(user));
  }
};

export const clearAuthSession = () => {
  SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
  clearSsoCallbackMarkers();
  localStorage.removeItem("trenitalia_session_id");
};

export const getStoredRefreshToken = () => {
  return sessionStorage.getItem("refresh_token");
};

export const getAuthProvider = () => {
  return sessionStorage.getItem("auth_provider") || AUTH_PROVIDER.CUSTOM_OAUTH2;
};

export const hasValidStoredSession = () => {
  return Boolean(
    sessionStorage.getItem("access_token") &&
      sessionStorage.getItem("refresh_token")
  );
};

export const storeLogoutNotification = (message) => {
    sessionStorage.setItem(LOGOUT_NOTIFICATION_KEY, message);
  };

  export const consumeLogoutNotification = () => {
    const message = sessionStorage.getItem(LOGOUT_NOTIFICATION_KEY);

    if (message) {
      sessionStorage.removeItem(LOGOUT_NOTIFICATION_KEY);
    }

    return message;
  };